module.exports = "../fonts/font-mfizz.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-mfizz/dist/font-mfizz.svg
// module id = 135
// module chunks = 0